import React, { useEffect } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FaPlay, FaCheck, FaCog, FaTools, FaIndustry, FaWrench } from 'react-icons/fa';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './Home.css';

const Home: React.FC = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      offset: 100
    });
  }, []);

  const services = [
    {
      icon: FaCog,
      title: 'Roscas Transportadoras',
      description: 'Recondicionamento completo com revestimento duro específico para cada aplicação industrial.'
    },
    {
      icon: FaTools,
      title: 'Tambor e Eixos',
      description: 'Recondicionamento de rotores e eixos com metalização e balanceamento eletrônico de precisão.'
    },
    {
      icon: FaIndustry,
      title: 'Redutores',
      description: 'Recondicionamento de caixas de engrenagens e cicloredutores de centrifugas industriais.'
    },
    {
      icon: FaWrench,
      title: 'Decanters',
      description: 'Locação, venda e recondicionamento completo de centrifugas decantadoras de alta performance.'
    }
  ];

  const portfolioItems = [
    {
      id: 1,
      image: '/portfolio-1.jpg',
      title: 'Centrifuga Industrial Chibrascenter',
      category: 'Manutenção Preventiva'
    },
    {
      id: 2,
      image: '/portfolio-2.jpg',
      title: 'Decanter Pieralisi Especializado',
      category: 'Fabricação Customizada'
    },
    {
      id: 3,
      image: '/portfolio-3.jpg',
      title: 'Sistema de Redução Avançado',
      category: 'Recondicionamento'
    },
    {
      id: 4,
      image: '/portfolio-4.jpg',
      title: 'Roscas Transportadoras',
      category: 'Recondicionamento'
    },
    {
      id: 5,
      image: '/portfolio-5.jpg',
      title: 'Tambor e Eixos Industriais',
      category: 'Metalização'
    },
    {
      id: 6,
      image: '/portfolio-6.jpg',
      title: 'Redutores de Alta Performance',
      category: 'Manutenção Especializada'
    }
  ];

  return (
    <div className="home-page">
      {/* Hero Section */}
      <section className="hero-section">
        <Container>
          <Row className="align-items-center">
            <Col lg={6} data-aos="fade-right">
              <div className="hero-content">
                <h1>Especialistas em Centrifugas Industriais</h1>
                <h2>Mais de 25 anos de experiência no mercado</h2>
                <p>
                  A MR Centrifugas é especializada em manutenção e fabricação de peças
                  para centrifugas e decanters industriais de diversas marcas, incluindo
                  Chibrascenter e Pieralisi.
                </p>
                <div className="hero-buttons">
                  <Link to="/sobre" className="btn btn-primary me-3">
                    Conheça Nossa História
                  </Link>
                  <Button variant="outline-primary" className="btn-video">
                    <FaPlay className="me-2" />
                    Ver Nossos Trabalhos
                  </Button>
                </div>
              </div>
            </Col>
            <Col lg={6} data-aos="fade-left">
              <div className="hero-image">
                <img
                  src="/centrifugas.png"
                  alt="Centrifugas Industriais MR Centrifugas"
                  className="img-fluid"
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* About Section */}
      <section className="section about-section">
        <Container>
          <Row className="align-items-center">
            <Col lg={6} data-aos="fade-right">
              <div className="about-content">
                <h2>MR Centrifugas - Sua Parceira Industrial</h2>
                <p>
                  Desde 2016, somos especialistas em manutenção e fabricação de peças
                  para centrifugas e decanters industriais. Nossa missão é fornecer
                  soluções completas e inovadoras para o setor industrial.
                </p>
                <ul className="about-features">
                  <li>
                    <FaCheck className="check-icon" />
                    <span>
                      <strong>CEO Marcelo Rezende</strong> com mais de 25 anos de
                      experiência no ramo industrial.
                    </span>
                  </li>
                  <li>
                    <FaCheck className="check-icon" />
                    <span>
                      <strong>Manutenções preventivas e corretivas</strong> com
                      equipe técnica especializada.
                    </span>
                  </li>
                  <li>
                    <FaCheck className="check-icon" />
                    <span>
                      <strong>Atendimento nacional</strong> em diversos estados
                      do Brasil.
                    </span>
                  </li>
                  <li>
                    <FaCheck className="check-icon" />
                    <span>
                      <strong>Especialização</strong> em Chibrascenter e Pieralisi.
                    </span>
                  </li>
                </ul>
                <Link to="/sobre" className="btn btn-primary">
                  Saiba Mais Sobre Nós
                </Link>
              </div>
            </Col>
            <Col lg={6} data-aos="fade-left">
              <div className="about-image">
                <img
                  src="/why-br-2.jpg"
                  alt="MR Centrifugas - Nossa Empresa"
                  className="img-fluid rounded"
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Services Section */}
      <section className="section services-section">
        <Container>
          <div className="section-title" data-aos="fade-up">
            <h2>Nossos Serviços Especializados</h2>
            <p>
              Serviços especializados em Decanters de quaisquer marca ou procedência,
              aplicada em diversas atividades industriais com qualidade garantida.
            </p>
          </div>

          <Row>
            {services.map((service, index) => {
              const IconComponent = service.icon;
              return (
                <Col lg={3} md={6} key={index} data-aos="fade-up" data-aos-delay={index * 100}>
                  <div className="service-card">
                    <div className="service-icon">
                      <IconComponent />
                    </div>
                    <h4>{service.title}</h4>
                    <p>{service.description}</p>
                  </div>
                </Col>
              );
            })}
          </Row>
        </Container>
      </section>

      {/* CTA Section */}
      <section className="section cta-section">
        <Container>
          <Row className="justify-content-center text-center">
            <Col lg={8} data-aos="fade-up">
              <h2>Solicite seu Orçamento Especializado</h2>
              <p>
                Nossa equipe técnica está preparada para atender sua necessidade
                com soluções personalizadas e orçamentos competitivos.
              </p>
              <Link to="/contato" className="btn btn-primary btn-lg">
                Solicitar Orçamento Agora
              </Link>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Portfolio Section */}
      <section className="section portfolio-section">
        <Container>
          <div className="section-title" data-aos="fade-up">
            <h2>Nossos Principais Trabalhos</h2>
            <p>Algumas das nossas realizações em diversas indústrias</p>
          </div>

          <Row>
            {portfolioItems.map((item, index) => (
              <Col lg={4} md={6} key={item.id} data-aos="fade-up" data-aos-delay={index * 100}>
                <div className="portfolio-card">
                  <div className="portfolio-image">
                    <img
                      src={item.image}
                      alt={item.title}
                      className="img-fluid"
                      onError={(e) => {
                        const target = e.target as HTMLImageElement;
                        target.src = '/portfolio-placeholder.jpg';
                      }}
                    />
                    <div className="portfolio-overlay">
                      <div className="portfolio-info">
                        <h4>{item.title}</h4>
                        <p>{item.category}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            ))}
          </Row>

          <div className="text-center mt-4" data-aos="fade-up">
            <Link to="/portfolio" className="btn btn-outline-primary">
              Ver Todos os Trabalhos
            </Link>
          </div>
        </Container>
      </section>
    </div>
  );
};

export default Home; 